import { render, staticRenderFns } from "./ModalExcluirCliente.vue?vue&type=template&id=456a66af"
import script from "./ModalExcluirCliente.vue?vue&type=script&lang=js"
export * from "./ModalExcluirCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports